export const sampleSettings = {
  teamName: 'Sample',
  settings: {
    hasCourses: { display: true, value: 'Cursos' },
    hasEvents: { display: true, value: 'Eventos' },
    hasTools: { display: true, value: 'Ferramentas' },
    hasStore: { display: true, value: 'Loja' },
    hasHistorical: true,
    hasRecaptcha: true,
    hasApplications: true,
    hasUsersEngagement: true,
    displayGenderField: true,
    userFilter: ['Gênero', 'Setor', 'Tags', 'Login', 'Atividade'],
    userTypes: [
      'Administrador',
      'Usuário App',
      'Speaker',
      'Externo',
      'Convidado',
      'PJ',
      'Editor de Loja',
      'Editor de Conteúdo'
    ],
    hasBrands: false,
    hasAcademyRole: true
  }
};

export const teamSettings = [
  {
    teamName: 'grupopardini',
    settings: {
      hasCourses: { display: true, value: 'Você sabia?' },
      hasEvents: { display: true, value: 'Acontece' },
      hasTools: { display: true, value: 'Dia a Dia' },
      hasStore: { display: false },
      hasHistorical: false,
      hasApplications: false,
      hasUsersEngagement: false,
      displayGenderField: false,
      userTypes: ['Administrador', 'Usuário App', 'Speaker', 'PJ'],
      userFilter: ['Setor', 'Tags', 'Login'],
      hasBrands: true,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'MRN',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Aplicativos' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker', 'Externo'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'youseed',
    settings: {
      hasApplications: true,
      hasTools: { display: false, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'big',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'ETs',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'FERAs',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'Pintou Parceria Suvinil',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: [
        'Administrador',
        'Usuário App',
        'Speaker',
        'Editor de Loja',
        'Editor de Conteúdo'
      ],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login', 'Atividade'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'PetroRio',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'demo',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'ioasys',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'hubsocial',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'Team',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'programa de estagio',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'noz',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'The Bakery Brasil',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'safers',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'Sou SmarttBotter',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Links Úteis' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'Time Cibra',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker', 'Convidado'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'astro',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'ligga',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'Bosque',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'somosmachado',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Ferramentas' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
  {
    teamName: 'Grupo Arizona',
    settings: {
      hasApplications: false,
      hasTools: { display: true, value: 'Links Úteis' },
      userTypes: ['Administrador', 'Usuário App', 'Speaker'],
      userFilter: ['Gênero', 'Setor', 'Tags', 'Login'],
      hasBrands: false,
      hasAcademyRole: false
    }
  },
];
